var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteractive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m2.75 12c0-5.10863 4.14137-9.25 9.25-9.25 5.0825 0 9.2077 4.09923 9.2497 9.1718.0034.4142.342.7472.7562.7437.4142-.0034.7472-.3419.7437-.7561-.0487-5.89545-4.8428-10.6594-10.7496-10.6594-5.93706 0-10.75 4.81294-10.75 10.75 0 5.9068 4.76395 10.7009 10.6594 10.7496.4142.0035.7527-.3295.7561-.7437.0035-.4142-.3295-.7528-.7437-.7562-5.07257-.042-9.1718-4.1672-9.1718-9.2497zm9.25-4.25c-2.34721 0-4.25 1.90279-4.25 4.25 0 1.7835 1.09882 3.3122 2.6592 3.9425.3841.1551.5697.5922.4145.9763-.1551.3841-.5922.5696-.97631.4145-2.10789-.8515-3.59739-2.9176-3.59739-5.3333 0-3.17564 2.57436-5.75 5.75-5.75 2.4157 0 4.4818 1.4895 5.3333 3.59739.1551.38411-.0304.82121-.4145.97631-.3841.1552-.8212-.0304-.9763-.4145-.6303-1.56038-2.159-2.6592-3.9425-2.6592zm2.6699 13.5114-2.6126-7.8379c-.2815-.8443.5219-1.6477 1.3662-1.3662l7.8379 2.6126c.9848.3283.9848 1.7212 0 2.0494l-2.8942.9648c-.3225.1075-.5756.3606-.6831.6831l-.9648 2.8942c-.3282.9848-1.7211.9848-2.0494 0z",
    fill: "#28303f",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractive);
export default __webpack_public_path__ + "static/media/interactive.adb59046012215f6f4eeca96176fb8a4.svg";
export { ForwardRef as ReactComponent };